<section>
    <form [formGroup]="filterForm" (ngSubmit)="sendFilter()" class="section-filter">
        <mat-form-field class="search-input">
            <mat-label>Buscar</mat-label>
            <input matInput formControlName="search">
        </mat-form-field>
        <mat-form-field>
            <mat-label>Mostrar</mat-label>
            <mat-select (selectionChange)="changeSelect()" formControlName="favorite">
                <mat-option value="true">Favoritos</mat-option>
                <mat-option value="false">No favoritos</mat-option>
                <mat-option value="">Todos</mat-option>
            </mat-select>
        </mat-form-field>
    </form>
</section>